import { errorGQLHandler } from '../../../helpers/helpers';
import NOTICIA_CATEGORIA from '../../../graphql/revista/queries/NoticiaCategoria.gql';
import ACESSO_NOTIFICACAO from '@/graphql/revista/queries/AcessoInformeComercial.gql';
import * as types from '../../types/post-categoria.types';
import env from '@/config/env';

export default {
  namespaced: true,
  state: {
    informe: null,
    carregando: {
      noticia: true,
      more: false,
    },
    paginate: {
      currentPage: 1,
      next: 1,
      showButton: false,
      perPage: 20,
      totalPages: 0,
      total: 0,
      from: 1,
      to: 1,
    },
    data: [],
  },
  getters: {
    carregando: state => state.carregando,
    getData: state => state.data,
    showButton: state => state.paginate.showButton,
    paginate: state => state.paginate
  },
  mutations: {
    [types.NOTICIA](state, payload) {
      state.carregando.noticia = false;
      state.data = payload;
    },
    [types.MORE_NOTICIA](state, payload) {
      payload.forEach(item => {
        state.data.push(item);
      });
      state.carregando.more = false;
    },
    [types.PAGINATE_NOTICIA](state, payload) {
      state.carregando.more = false;
      const totalPages = Math.ceil(payload.total / payload.per_page);
      const showButton = payload.current_page < totalPages;
      state.paginate.showButton = showButton;
      state.paginate.currentPage = payload.current_page;
      state.paginate.next = totalPages > payload.current_page ? payload.current_page + 1 : null;
      state.paginate.perPage = payload.per_page;
      state.paginate.totalPages = totalPages;
      state.paginate.from = payload.from;
      state.paginate.to = payload.to;
      state.paginate.total = payload.total;
    },
    [types.INFORME_COMERCIAL](state, payload) {
      state.informe = payload;
    },
  },
  actions: {
    async getNoticias({ commit, dispatch, state, rootGetters }, payload) {
      try {
        state.carregando.noticia = true;
        state.data = [];
        const uf = await rootGetters['user/uf'];
        if (state.informe === null) {
          await dispatch('informeComercial');
        }
        const informe = state.informe === null ? await state.informe : state.informe;
        if (uf) {

          const query = await env.apolloRevista.query({
            query: NOTICIA_CATEGORIA,
            variables: {
              modulo: env.revista.modulo,
              canal: rootGetters['home/canal'],
              categoriaSlug: payload.slug,
              uf: [uf],
              page: payload.page,
              paginate: state.paginate.perPage,
              informe,
            },
            fetchPolicy: 'no-cache',
          });

          const { data, ...paginate } = query.data.noticias;

          commit(types.NOTICIA, data);
          commit(types.PAGINATE_NOTICIA, paginate);
        }
        state.carregando.noticia = false;
      } catch (e) {
        errorGQLHandler(e);
      }
    },
    async getMoreNoticias({ commit, state, rootGetters }, payload) {
      try {
        state.carregando.more = true;
        const uf = await rootGetters['user/uf'];
        const { informe } = state;
        if (uf) {
          const query = await env.apolloRevista.query({
            query: NOTICIA_CATEGORIA,
            variables: {
              modulo: env.revista.modulo,
              categoriaSlug: payload.slug,
              uf: [uf],
              page: payload.page,
              paginate: state.paginate.perPage,
              informe,
            },
            fetchPolicy: 'no-cache',
          });

          const { data, ...paginate } = query.data.noticias;
          commit(types.MORE_NOTICIA, noticias.data);
          commit(types.PAGINATE_NOTICIA, paginate);
        }
      } catch (e) {
        errorGQLHandler(e);
      }
    },
    async informeComercial({ commit, state }) {
      const enabled = await env.apolloRevista.query({
        query: ACESSO_NOTIFICACAO,
        variables: {},
        fetchPolicy: 'no-cache',
      });
      try {
        const {
          data: { acesso },
        } = enabled;

        const informe = +acesso;

        commit(types.INFORME_COMERCIAL, informe);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
